// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
.side_cart_wrapper {
  position: fixed;
  right: 0px;
  top: 0;
  bottom: 0;
  width: 275px;
  background: #fff;
  box-shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;
  min-height: 100vh;
  height: 100vh;
  z-index: 97;
  transition: all 400ms;
  animation-duration: 1000ms;
  opacity: 0;
  transform: translateX(275px);
}
.side_cart_wrapper.show {
  animation: slide-in 400ms forwards;
}
.side_cart_wrapper .sidebar_total {
  position: absolute;
  bottom: 100px;
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  font-size: 20px;
}
.side_cart_wrapper .close_side_cart_wrapper {
  background: rgb(255, 132, 35);
  padding: 5px;
  cursor: pointer;
  transition: all 200ms;
}
.side_cart_wrapper .close_side_cart_wrapper:hover {
  filter: brightness(1.1);
}
.side_cart_wrapper .close_side_cart_wrapper .close_side_cart {
  color: rgb(255, 255, 255);
  position: absolute;
  right: 8px;
  top: 5px;
}
.side_cart_wrapper .close_side_cart_wrapper .side_cart_title {
  text-align: center;
  padding: 5px;
  color: rgb(255, 255, 255);
  font-size: 18px;
}
.side_cart_wrapper .products_wrapper {
  position: relative;
  overflow-y: auto;
  max-height: calc(100% - 200px);
}
.side_cart_wrapper .products_wrapper .product_item {
  position: relative;
  transform: translateX(275px);
  min-height: 100px;
  margin: 15px 5px;
  padding: 5px;
  background: rgb(253, 253, 253);
  border-radius: 0px;
  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;
  animation: slide-in 400ms forwards;
  display: flex;
  align-items: center;
  justify-content: center;
}
.side_cart_wrapper .products_wrapper .product_item .delete_item {
  position: absolute;
  top: 0px;
  right: 4px;
  color: rgba(0, 0, 0, 0.6);
  transition: 200ms;
  cursor: pointer;
}
.side_cart_wrapper .products_wrapper .product_item .delete_item:hover {
  color: rgb(255, 0, 0);
}
.side_cart_wrapper .products_wrapper .product_item .product_info {
  flex: 2 1;
}
.side_cart_wrapper .products_wrapper .product_item .product_info .product_title {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.6);
}
.side_cart_wrapper .products_wrapper .product_item .product_info .product_price {
  color: rgb(124, 187, 46);
  font-size: 24px;
}
.side_cart_wrapper .products_wrapper .product_item .product_info .product_variants_wrapper .product_variant {
  font-size: 12px;
}
.side_cart_wrapper .products_wrapper .product_item .product_info .product_variants_wrapper .product_variant .variant_name {
  color: rgba(0, 0, 0, 0.6);
  margin-right: 5px;
}
.side_cart_wrapper .products_wrapper .product_item .qty_wrapper {
  flex: 1 1;
}
.side_cart_wrapper .checkout_process_button {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 20px;
  width: 80%;
  margin: 0px;
  left: 50%;
  transform: translateX(-50%);
}

.products_wrapper .product_item:nth-child(1n) {
  animation-delay: 0.1s;
}

.products_wrapper .product_item:nth-child(2n) {
  animation-delay: 0.2s;
}

.products_wrapper .product_item:nth-child(3n) {
  animation-delay: 0.3s;
}

.products_wrapper .product_item:nth-child(4n) {
  animation-delay: 0.4s;
}

.products_wrapper .product_item:nth-child(5n) {
  animation-delay: 0.5s;
}

.products_wrapper .product_item:nth-child(6n) {
  animation-delay: 0.6s;
}

.products_wrapper .product_item:nth-child(7n) {
  animation-delay: 0.7s;
}

.products_wrapper .product_item:nth-child(8n) {
  animation-delay: 0.8s;
}

.products_wrapper .product_item:nth-child(9n) {
  animation-delay: 0.9s;
}

.products_wrapper .product_item:nth-child(10n) {
  animation-delay: 1s;
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateX(275px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.side_cart_background {
  position: fixed;
  z-index: 96;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(30, 30, 30, 0.3);
}
.side_cart_background.show {
  animation: fadeIn 400ms forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.side_cart_min {
  position: fixed;
  bottom: 40px;
  right: 40px;
  height: 50px;
  width: 50px;
  background: rgb(255, 132, 35);
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;
  z-index: 97;
  cursor: pointer;
}
.side_cart_min:hover {
  filter: brightness(1.1);
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/orders/side-cart/_sideCart.scss"],"names":[],"mappings":"AAGA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;AC9BR;ADgCI;EACI,mCAAA;AC9BR;;ADkCI;EACI,wCAAA;AC/BR;ADiCI;EACI,mCAAA;AC/BR;;ADmCI;EACI,wCAAA;AChCR;ADkCI;EACI,mCAAA;AChCR;;ADoCI;EACI,wCAAA;ACjCR;ADmCI;EACI,mCAAA;ACjCR;;ADqCI;EACI,qCAAA;AClCR;ADoCI;EACI,gCAAA;AClCR;;ADsCI;EACI,wCAAA;ACnCR;ADqCI;EACI,mCAAA;ACnCR;;ADuCI;EACI,uCAAA;ACpCR;ADsCI;EACI,kCAAA;ACpCR;;ADwCI;EACI,wCAAA;ACrCR;ADuCI;EACI,mCAAA;ACrCR;;ADwCA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AC9HA;EACI,eAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,gBDqBuB;ECpBvB,kDDuGc;ECtGd,iBAAA;EACA,aAAA;EACA,WDwHS;ECvHT,qBAAA;EACA,0BAAA;EACA,UAAA;EACA,4BAAA;AAkEJ;AAhEI;EACI,kCAAA;AAkER;AA/DI;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,yBDPe;ECQf,eAAA;AAiER;AA9DI;EACI,6BDxBC;ECyBD,YAAA;EACA,eAAA;EACA,qBAAA;AAgER;AA9DQ;EACI,uBAAA;AAgEZ;AA7DQ;EACI,yBDrBO;ECsBP,kBAAA;EACA,UAAA;EACA,QAAA;AA+DZ;AA5DQ;EACI,kBAAA;EACA,YAAA;EACA,yBD9BO;EC+BP,eAAA;AA8DZ;AA1DI;EACI,kBAAA;EACA,gBAAA;EACA,8BAAA;AA4DR;AA1DQ;EACI,kBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,8BDrCiB;ECsCjB,kBDmDI;EClDJ,8CD6CQ;EC5CR,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA4DZ;AA1DY;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBD3DO;EC4DP,iBD6CG;EC5CH,eAAA;AA4DhB;AA3DgB;EACI,qBD1Ed;ACuIN;AAzDY;EACI,SAAA;AA2DhB;AA1DgB;EACI,eAAA;EACA,yBDvEG;ACmIvB;AA1DgB;EACI,wBDxFZ;ECyFY,eAAA;AA4DpB;AAzDoB;EACI,eAAA;AA2DxB;AA1DwB;EACI,yBDjFL;ECkFK,iBAAA;AA4D5B;AArDY;EACI,SAAA;AAuDhB;AAhDI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;AAkDR;;AA7CI;EACI,qBAAA;AAgDR;;AAjDI;EACI,qBAAA;AAoDR;;AArDI;EACI,qBAAA;AAwDR;;AAzDI;EACI,qBAAA;AA4DR;;AA7DI;EACI,qBAAA;AAgER;;AAjEI;EACI,qBAAA;AAoER;;AArEI;EACI,qBAAA;AAwER;;AAzEI;EACI,qBAAA;AA4ER;;AA7EI;EACI,qBAAA;AAgFR;;AAjFI;EACI,mBAAA;AAoFR;;AAhFA;EACI;IACI,UAAA;IACA,4BAAA;EAmFN;EAjFE;IACI,UAAA;IACA,wBAAA;EAmFN;AACF;AAhFA;EACI,eAAA;EACA,WDhBoB;ECiBpB,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,iCAAA;AAkFJ;AAhFI;EACI,gCAAA;AAkFR;;AA9EA;EACI;IACI,UAAA;EAiFN;EA/EE;IACI,UAAA;EAiFN;AACF;AA9EA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BDxKK;ECyKL,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kDDtEc;ECuEd,WDnDS;ECoDT,eAAA;AAgFJ;AA9EI;EACI,uBAAA;AAgFR","sourcesContent":["// @import './variables';\r\n// @import './common';\r\n\r\n/*Colors */\r\n/****BRAND COLORS*****/\r\n$blue: rgb(22,109,255);\r\n$green: rgb(124,187,46);\r\n$gold: rgb(255,189,28);\r\n$orange: rgb(255,132,35);;\r\n$red: rgb(255,0,0);\r\n$pink: rgb(255,47,154);\r\n$purple: rgb(177,0,234);\r\n$cyan: rgb(48,205,155);\r\n/****END BRAND COLORS*****/\r\n$color_gray: rgb(198, 198, 198);\r\n$color_undefined: rgb(198, 198, 198);\r\n$color_primary: rgb(22,109,255);\r\n$color_error: rgb(224, 70, 70);\r\n$color_disabled: rgba(30,30,30,.3);\r\n$text_color_dark: rgba(0,0,0,1);\r\n$text_color_dark_soft: rgba(0,0,0,.6); \r\n$text_color_light: rgba(255,255,255,1);\r\n$text_color_light_soft: rgba(255,255,255,.5);\r\n$border_color_primary: rgba(30,30,30,.2);\r\n$button_border_color_primary: rgba(31, 74, 193, 1);\r\n$placeholder_color: rgba(30,30,30,.2);\r\n$placeholder_color_hover: rgba(30,30,30,.5);\r\n$navigation_button_color_hover: rgba(194, 205, 238, 0.2);\r\n\r\n$background_color_primary: #fff;\r\n$background_color_secondary: rgb(253, 253, 253);\r\n\r\n\r\n/* Color Classes*/\r\n/*#region*/\r\n.blue {\r\n    &.background {\r\n        background: $blue !important;\r\n    }\r\n    &.text {\r\n        color: $blue !important;\r\n    }\r\n}\r\n.green {\r\n    &.background {\r\n        background: $green !important;\r\n    }\r\n    &.text {\r\n        color: $green !important;\r\n    }\r\n}\r\n.gold {\r\n    &.background {\r\n        background: $gold !important;\r\n    }\r\n    &.text {\r\n        color: $gold !important;\r\n    }\r\n}\r\n.orange {\r\n    &.background {\r\n        background: $orange !important; \r\n    }\r\n    &.text {\r\n        color: $orange !important;\r\n    }\r\n}\r\n.red {\r\n    &.background {\r\n        background: $red !important;\r\n    }\r\n    &.text {\r\n        color: $red !important;\r\n    }\r\n}\r\n.pink {\r\n    &.background {\r\n        background: $pink !important;\r\n    }\r\n    &.text {\r\n        color: $pink !important;\r\n    }\r\n}\r\n.purple {\r\n    &.background {\r\n        background: $purple !important;\r\n    }\r\n    &.text {\r\n        color: $purple !important;\r\n    }\r\n}\r\n.cyan {\r\n    &.background {\r\n        background: $cyan !important;\r\n    }\r\n    &.text {\r\n        color: $cyan !important;\r\n    }\r\n}\r\n/*#endregion*/\r\n\r\n/* Font */\r\n$font_size_button: 14px;\r\n$font_size_navigation: 16px;\r\n$font_size_standard: 14px;\r\n$font_size_subtitle: 24px;\r\n$font_size_small: 12px;\r\n\r\n/* Shadows */\r\n$soft_shadow: rgba(0, 0, 0, 0.2) 0px 24px 38px 3px;\r\n$row_shadow: rgba(50,50,50,.1) 2px 3px 10px;\r\n$row_shadow_hover: rgba(50,50,50,.15) 4px 5px 10px;\r\n$side_nav_shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\r\n//$form_input_shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px 0px; //original\r\n$form_input_shadow: rgba(30,30, 30, .1) 2px 2px 10px ;\r\n//$form_input_shadow_hover: rgba(0, 0, 0, 0.11) 2px 14px 10px 0px; //original\r\n$form_input_shadow_hover: rgba(30,30, 30, .15) 4px 4px 15px ;\r\n\r\n/* Borders */\r\n$border_radius: 0px;\r\n$border_button_radius: 0px;\r\n$border_active_width: 0px;\r\n$border_round: 20px;\r\n\r\n/* Transitions and Animations*/\r\n$transition_speed: 200ms;\r\n$animation_speed: 400ms; //currently used for fading in modal\r\n\r\n/* Z Index */\r\n$z_loader: 403;\r\n$z_modal_foreground: 402;\r\n$z_modal_background: 401;\r\n$z_sidecart: 97;\r\n$z_sidecart_background: 96;\r\n$z_select_dropdown: 94;\r\n$z_navbar: 95;","@import \"../../../styles/variables\";\r\n\r\n.side_cart_wrapper {\r\n    position: fixed;\r\n    right: 0px;\r\n    top: 0;\r\n    bottom: 0;\r\n    width: 275px;\r\n    background: $background_color_primary;\r\n    box-shadow: $side_nav_shadow;\r\n    min-height: 100vh;\r\n    height: 100vh;\r\n    z-index: $z_sidecart;\r\n    transition: all $animation_speed;\r\n    animation-duration: 1000ms;\r\n    opacity: 0;\r\n    transform: translateX(275px);\r\n\r\n    &.show {\r\n        animation: slide-in $animation_speed forwards;\r\n    }\r\n\r\n    .sidebar_total {\r\n        position: absolute;\r\n        bottom: 100px;\r\n        width: 100%;\r\n        text-align: center;\r\n        color: $text_color_dark_soft;\r\n        font-size: 20px;\r\n    }\r\n\r\n    .close_side_cart_wrapper {\r\n        background: $orange;\r\n        padding: 5px;\r\n        cursor: pointer;\r\n        transition: all $transition_speed;\r\n\r\n        &:hover {\r\n            filter: brightness(1.1);\r\n        }\r\n\r\n        .close_side_cart {\r\n            color: $text_color_light;\r\n            position: absolute;\r\n            right: 8px;\r\n            top: 5px;\r\n        }\r\n\r\n        .side_cart_title {\r\n            text-align: center;\r\n            padding: 5px;\r\n            color: $text_color_light;\r\n            font-size: 18px;\r\n        }\r\n    }\r\n\r\n    .products_wrapper {\r\n        position: relative;\r\n        overflow-y: auto;\r\n        max-height: calc(100% - 200px);\r\n\r\n        .product_item {\r\n            position: relative;\r\n            transform: translateX(275px);\r\n            min-height: 100px;\r\n            margin: 15px 5px;\r\n            padding: 5px;\r\n            background: $background_color_secondary;\r\n            border-radius: $border-radius;\r\n            box-shadow: $form_input_shadow;\r\n            animation: slide-in $animation_speed forwards;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n\r\n            .delete_item {\r\n                position: absolute;\r\n                top: 0px;\r\n                right: 4px;\r\n                color: $text_color_dark_soft;\r\n                transition: $transition_speed;\r\n                cursor: pointer;\r\n                &:hover {\r\n                    color: $red;\r\n                }\r\n            }\r\n\r\n            .product_info {\r\n                flex: 2;\r\n                .product_title {\r\n                    font-size: 20px;\r\n                    color: $text_color_dark_soft;\r\n                }\r\n                .product_price {\r\n                    color: $green;\r\n                    font-size: 24px;\r\n                }\r\n                .product_variants_wrapper {\r\n                    .product_variant {\r\n                        font-size: 12px;\r\n                        .variant_name {\r\n                            color: $text_color_dark_soft;\r\n                            margin-right: 5px;\r\n                        }\r\n                        .variant_value {\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .qty_wrapper {\r\n                flex: 1;\r\n                .qty {\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .checkout_process_button {\r\n        position: absolute;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        bottom: 20px;\r\n        width: 80%;\r\n        margin: 0px;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n    }\r\n}\r\n\r\n@for $i from 1 through 10 {\r\n    .products_wrapper .product_item:nth-child(#{$i}n) {\r\n        animation-delay: #{$i * 0.1}s;\r\n    }\r\n}\r\n\r\n@keyframes slide-in {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translateX(275px);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translateX(0);\r\n    }\r\n}\r\n\r\n.side_cart_background {\r\n    position: fixed;\r\n    z-index: $z_sidecart_background;\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    background: rgba(30, 30, 30, 0.3);\r\n\r\n    &.show {\r\n        animation: fadeIn $animation_speed forwards;\r\n    }\r\n}\r\n\r\n@keyframes fadeIn {\r\n    0% {\r\n        opacity: 0;\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.side_cart_min {\r\n    position: fixed;\r\n    bottom: 40px;\r\n    right: 40px;\r\n    height: 50px;\r\n    width: 50px;\r\n    background: $orange;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-shadow: $side_nav_shadow;\r\n    z-index: $z_sidecart;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n        filter: brightness(1.1);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
